import { XpressDisciplinaryType } from 'app/models';

export class XpressDisciplinaryTypeModel {
    public static XpressDisciplinaryTypeList: Array<any> = [
        { name: 'Manually', value: XpressDisciplinaryType.Manually },
        { name: 'Automated', value: XpressDisciplinaryType.Automated }
    ];
}
